import styled, { css } from 'styled-components';

export const SidebarContainer = styled.div<{
  isOpen: boolean;
  isMobile: boolean;
  version?: string;
}>`
  border-radius: 0px 0px 20px 0px;
  box-shadow: 4px 0px 10px rgba(0, 0, 0, 0.13);
  ${({ isMobile, theme, isOpen }) => css`
    background-color: ${theme.sidebar.background};
    ${isOpen
      ? css`
          height: ${isMobile ? 'calc(100vh - 84px)' : 'calc(100vh - 72px)'};
          padding: 24px 24px 0px 24px;
        `
      : css`
          height: 0;
        `}
    color: ${theme.sidebar.color};
  `}
  transition: all 0.3s;
  position: absolute;
  top: 100%;
  left: 0;
  overflow: hidden;
  min-width: 233px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
